export default __webpack_public_path__ + "static/media/HappyBirthday_19.746541bf.png";